import {
  mapGetters,
} from 'vuex';

import europeanUnionIcon from '@/assets/images/icons/european-union.svg';


export default {
  name: 'Title',
  components: {
    europeanUnionIcon,
  },
  props: {
    title: '',
    previousStepTitle: '',
  },
  data: () => ({

  }),
  computed: {
    ...mapGetters('appointment', {
      licensePlate: 'getLicensePlate',
    }),
  },
  methods: {
    goToPreviousStep() {
      this.$emit('on-go-to-previous-step');
    },
  },
};
